/** @module Debug/NewProfileSession */
define([
	"dojo/_base/declare",
	"dojo/_base/window",
	"dojo/topic",
	"csi/_base/underscore",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/comm",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/types",
	"csi/util",
	"csi/xml",
	"csi/xml/Writer",
	"src/c8-platform/core/request"
], function(declare, win, topic, _, ActionView, Controller, comm, PostRequest, def, types, util, xml, Writer, axiosRequest) {

	var profUrl;
	var profSession;
	var profStartTime;
	var profWriter;

	function startProfile(/*String*/urlProfile, /*Writer*/writer) {
		// start server profiling
		new PostRequest("Profiler", "Enable", {"Enable": "true"}).post();

		// begin writing profile statistics
		profWriter = writer;
		profUrl = urlProfile;
		profSession = {
			requests: [],
			views: 0
		}
		profStartTime = types.getDateTime();
	}

	function stopProfile() {
		// summary: write profile operations
		var writer = profWriter;
		var endTime = types.getDateTime();
		var url;

		var requestUrls = _.map(profSession.requests, function(r) {
			url = comm.createUrl();

			writer.createNode(url, "_CS_ProfileRequest", r.name)
				.changeAttribute(xml.idGetComment(xml.ATTR_NAME), xml.ATTR_STRING, r.request)
				.changeAttribute("StartTime", xml.ATTR_TIME, r.start)
				.changeAttribute("EndTime", xml.ATTR_TIME, r.end)
				.changeAttribute("DBTime", xml.ATTR_DOUBLE, r.db)
				.changeAttribute("DBExecTime", xml.ATTR_DOUBLE, r.ex)
				.changeAttribute("NumDBReq", xml.ATTR_INTEGER, r.exCnt)
				.changeAttribute("TXTime", xml.ATTR_DOUBLE, r.txTime)
				.changeAttribute("PGTime", xml.ATTR_DOUBLE, r.pgTime)
				.changeAttribute("RSTime", xml.ATTR_DOUBLE, r.rsTime)
				.changeAttribute("RXTime", xml.ATTR_DOUBLE, r.rxTime)
				.changeAttribute("VLTime", xml.ATTR_DOUBLE, r.vlTime)
				.changeAttribute("CATime", xml.ATTR_DOUBLE, r.caTime)
				.changeAttribute("CXTime", xml.ATTR_DOUBLE, r.cxTime)
				.changeAttribute("QATime", xml.ATTR_DOUBLE, r.qa)
				.changeAttribute("ServerTime", xml.ATTR_DOUBLE, r.server)
				.changeAttribute("CommTime", xml.ATTR_DOUBLE, r.comm)
				.changeAttribute("NumChars", xml.ATTR_DOUBLE, r.size / 1024.0)
				.changeAttribute("Action", xml.ATTR_STRING, r.action)
				.changeAttribute("View", xml.ATTR_STRING, r.view)
				.changeAttribute("CustomView", xml.ATTR_REF, r.customView)
				.changeAttribute("Module", xml.ATTR_STRING, r.module)
				.changeAttribute("Operation", xml.ATTR_STRING, r.operation);

			return url;
		}, this);

		// write profile attributes
		writer.changeNode(profUrl)
			.changeAttribute("TotalTime", xml.ATTR_DOUBLE, endTime - profStartTime)
			.changeAttribute("StartTime", xml.ATTR_TIME, profStartTime)
			.changeAttribute("EndTime", xml.ATTR_TIME, endTime)
			.changeAttribute("Requests", xml.ATTR_REFVECTOR, requestUrls)
			.changeAttribute("NumViews", xml.ATTR_INTEGER, profSession.views)

		// reset all variables
		profUrl = profWriter = null;

		// stop server profiling
		new PostRequest("Profiler", "Enable", {"Enable": "false"}).post();

		return writer;
	}

	topic.subscribe("/csi/view", function(view) {
		if (profSession) {
			++profSession.views;
		}
	});

	topic.subscribe("/csi/xhr/end", function(dfd, req, text, xhr, content) {
		// summary: add profile request - currently cannot track performance of form submissions
		if (profSession) {
			const requestTime = xhr ? xhr.getResponseHeader("PIRequestTime") : 0;
			var s = "";
			var formData = {};
			if (typeof req == "object") {
				req.forEach(function(value, key) {
					formData[key] = value;
				});
				s = JSON.stringify(formData);
			} else if (typeof req == "string") {
				s = util.xmlToString(req);
			}
			if (!(s.includes("Module=Profiler") && s.includes("Operation=Enable"))) {
				profSession.requests.push({
					name: xhr ? xhr.getResponseHeader("PIRequestId") : "Form Submit",
					start: dfd.timeStart,
					end: dfd.timeEnd,
					request: s,
					size: text ? text.length : 0,
					action: content?.UI_Action,
					view: content?.UI_View,
					customView: content?.UI_CustomView,
					module: content?.Module,
					operation: content?.Operation,
					db: xhr ? xhr.getResponseHeader("PIRequestDBTime") : 0,
					ex: xhr ? xhr.getResponseHeader("PIRequestEXTime") : 0,
					exCnt: xhr ? xhr.getResponseHeader("PIRequestEXCount") : 0,
					txTime: xhr ? xhr.getResponseHeader("PIRequestTXTime") : 0,
					pgTime: xhr ? xhr.getResponseHeader("PIRequestPGTime") : 0,
					rsTime: xhr ? xhr.getResponseHeader("PIRequestRSTime") : 0,
					rxTime: xhr ? xhr.getResponseHeader("PIRequestRXTime") : 0,
					vlTime: xhr ? xhr.getResponseHeader("PIRequestVLTime") : 0,
					caTime: xhr ? xhr.getResponseHeader("PIRequestCATime") : 0,
					cxTime: xhr ? xhr.getResponseHeader("PIRequestCXTime") : 0,
					qa: xhr ? xhr.getResponseHeader("PIRequestRSTime") : 0, // Query Accelerator
					comm: xhr ? (dfd.timeDiff - requestTime) : dfd.timeDiff,
					server: requestTime
				});
			}
		}
	});

	axiosRequest.registerResponseCallback((response, formData, startTime, endTime) => {
		if (profSession) {
			const timeDiff = endTime - startTime;
			const text = response.request?.responseText;
			const hdr = response.headers;
			const requestTime = hdr?.pirequesttime ?? 0;
			let s = "";
			if (typeof response == "object") {
				s = JSON.stringify(response);
			} else if (typeof response == "string") {
				s = util.xmlToString(response);
			}
			profSession.requests.push({
				name: hdr ? hdr.pirequestid : "Form Submit",
				start: startTime,
				end: endTime,
				request: s,
				size: text?.length ?? 0,
				db: hdr?.pirequestdbtime ?? 0,
				ex: hdr?.pirequestextime ?? 0,
				exCnt: hdr?.pirequestexcount ?? 0,
				txTime: hdr?.pirequesttxtime ?? 0,
				pgTime: hdr?.pirequestpgtime ?? 0,
				rsTime: hdr?.pirequestrstime ?? 0,
				rxTime: hdr?.pirequestrxtime ?? 0,
				vlTime: hdr?.pirequestvstime ?? 0,
				caTime: hdr?.pirequestcatime ?? 0,
				cxTime: hdr?.pirequestcxtime ?? 0,
				qa: hdr?.pirequestrstime ?? 0, // Query Accelerator
				comm: hdr ? (timeDiff - requestTime) : timeDiff,
				server: requestTime,

				action: formData.get("UI_Action"),
				view: formData.get("UI_View"),
				customView: formData.get("UI_CustomView"),
				module: formData.get("Module"),
				operation: formData.get("Operation")
			});
		}
	});

	return declare(Controller, {
		/**
		* Open NewProfile form if toggling on
		*/
		getActionView: function(vr) {
			return this.m_bToggle ? null : new ActionView(this, def.typeDefinition("_CS_ProfileSession").getViewDef("NewProfile"));
		},

		/**
		* Copied from NewController - clear node in FormData since creating a new session
		*/
		getFormData: function() {
			var data = this.inherited(arguments);
			data.m_node = null;
			return data;
		},

		/**
		* Start/stop capturing of actions and requests
		*/
		toWriter: function() {
			if (this.m_bToggle) {
				// swap writers again now that we are ready to create profile data
				this.m_writer = stopProfile();
			} else {
				// create profile session
				var fd = this.m_formData;
				var name = fd.getFieldValue(xml.ATTR_NAME, true);
				var desc = fd.getFieldValue("Description", true);
				var url = comm.createUrl();

				this.m_writer.createNode(url, "_CS_ProfileSession", name).changeAttribute("Description", xml.ATTR_STRING, desc);

				// swap writers so nothing will be written until the profile is stopped
				startProfile(url, this.m_writer);
				this.m_writer = new Writer();
			}
		},

		postProcess: function(/*Boolean*/bStatus, /*Boolean*/bRepeat) {
			// summary: if action failed or was cancelled, restore toggle state
			if (!bStatus) {
				this.actionWidget.set("checked", false, false);
			}

			this.inherited(arguments);
		}
	});
});
